import { EligibilityGroupValues } from '../../../types';

export function getGroupById(id: number, groups: EligibilityGroupValues[]): EligibilityGroupValues {
	if (!groups) {
		return null;
	}
	return groups.find((group) => group.id === id);
}
